import { useCallback, useRef } from "react";
import type { UseFlashCanvasArgs } from "./types";

export const useFlashCanvas = ({
  svgOverlayRef,
  canvasRef,
}: UseFlashCanvasArgs): ((duration?: number) => void) => {
  const flashTimeoutRef = useRef<number | null>(null);

  const flashCanvas = useCallback(
    (duration: number = 1500) => {
      if (!svgOverlayRef.current || !canvasRef.current) return;

      if (flashTimeoutRef.current !== null) {
        clearTimeout(flashTimeoutRef.current);
        svgOverlayRef.current.classList.remove("animate-flash");
        canvasRef.current.classList.remove("opacity-50");
      }

      svgOverlayRef.current.classList.add("animate-flash");
      canvasRef.current.classList.add("opacity-50");

      flashTimeoutRef.current = window.setTimeout(() => {
        svgOverlayRef.current?.classList.remove("animate-flash");
        canvasRef.current?.classList.remove("opacity-50");
        flashTimeoutRef.current = null;
      }, duration);
    },
    [svgOverlayRef, canvasRef],
  );

  return flashCanvas;
};
